import React from 'react';
import styled from 'styled-components';

import { Button, Icon } from '@column/column-ui-kit';

import { Flex, Text } from '~/styles';

import { RollingNumber } from './RollingNumber';

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 20px;
`;

interface PageCounterProps {
  current: number;
  total: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const PageCounter: React.FC<PageCounterProps> = ({ current, total, onPrevious, onNext }) => {
  const maxDigits = Math.max(String(current).length, String(total).length);
  const sizeTo = Math.max(Number('9'.repeat(maxDigits)), current, total);

  return (
    <Flex alignItems="center" flexDirection="row" gap={8}>
      <Button
        variant="muted"
        size="tiny"
        onlyIcon
        icon={<Icon.ChevronLeft />}
        ariaLabel="Previous"
        onClick={onPrevious}
        isDisabled={current === 1}
      />
      <CounterWrapper>
        <RollingNumber value={current} sizeTo={sizeTo}>
          {(value) => (
            <Text color="light" size={14} weight="medium">
              {value}
            </Text>
          )}
        </RollingNumber>
        <Text color="lighter" size={14} weight="medium">
          of
        </Text>
        <RollingNumber value={total} direction="down" sizeTo={sizeTo}>
          {(value) => (
            <Text color="light" size={14} weight="medium">
              {value}
            </Text>
          )}
        </RollingNumber>
      </CounterWrapper>
      <Button
        variant="muted"
        size="tiny"
        onlyIcon
        icon={<Icon.ChevronRight />}
        ariaLabel="Next"
        onClick={onNext}
        isDisabled={current === total}
      />
    </Flex>
  );
};
